<template>
	<transition name="scale-fade">
		<wrapper>
			<video
				slot="video" 
				class="video"
				@timeupdate="onTimeUpdateListener"
				@loadstart="onLoadStart"
				@playing="onPlaying"
				:autoplay="isWeekendEpisode"
				ref="video">
				<source v-if="episodeData" :src="videoSrc" type="video/mp4">
			</video>
			<div slot="components" v-if="episodeData">
				<component
					v-for="(game, index) in episodeData.components" :key="index"
					v-if="mountGame[index]"
					v-show="showGame[index]"
					:is="game.name"
					:config="game.config"
					:currentTime="currentTime"
				/>
				<transition name="fade">
					<a v-if="isTablet && playButtonIsVisible" @click="playVideo" class="play-button"><icon color="white" :src="require('@/assets/images/youtube/icon-play.svg')" /></a>
				</transition>
			</div>
		</wrapper>
	</transition>
</template>

<script>

import { mapState } from 'vuex'
import Wrapper from '@/components/episodes/Wrapper'
import Modernizr from 'modernizr'
import Icon from '@/components/Icon'

export default {

	components: {
		Wrapper,
		Icon
	},

	data() {
		return {
			currentTime: '',
			stopEpisode: false,
			isTablet: Modernizr.touchevents,
			playButtonIsVisible: true
		}
	},

	 mounted () {
	 	smarttag && smarttag('aflevering'+this.$route.params.id)

		this.$store.commit('SET_VIDEO', this.$refs.video)
		const episodeName = 'ep-' +  this.$route.params.id
		this.$store.dispatch('getEpisode', {
			episode: episodeName,
			router: this.$router
		})
	 },
	 computed: {
		...mapState([
			'currentChapter',
			'episodeData',
			'video',
			'episodeType'
		]),
		videoSrc () {
			return process.env.VIDEO_PATH + this.episodeData.src
		},
		showGame () {
			return this.episodeData.components.map((game) => {
				return this.currentTime >= this.episodeData.timeline[game.show.start[0]][game.show.start[1]] + game.show.start[2] &&
				this.currentTime < this.episodeData.timeline[game.show.end[0]][game.show.end[1]] + game.show.end[2]
			})
		},
		mountGame () {
			return this.episodeData.components.map((game) => {
				return this.currentTime >= this.episodeData.timeline[game.mount.start[0]][game.mount.start[1]] + game.mount.start[2] &&
					   this.currentTime < this.episodeData.timeline[game.mount.end[0]][game.mount.end[1]] + game.mount.end[2]
			})
		},
		isWeekendEpisode () {
			return this.episodeType == 'weekendEpisode'
		}
	},
	watch : {
		isWeekendEpisode:function(val) {
			if(val) {
				let promise = this.video.play()
				if (promise !== undefined) {
					promise.catch(error => {
						this.isTablet = true
					})
				}
			}
		},
	},
 	methods: {
		playVideo () {
			this.video.play()
			this.playButtonIsVisible = false
		},
		onPlaying () {
			this.$store.commit('SET_CURRENT_PLAYING_CHAPTER', this.currentChapter)
		},
		onTimeUpdateListener: function () {
			this.currentTime = this.video.currentTime;
			if (this.video.currentTime > this.episodeData.timeline[this.currentChapter].Out) {

				if( this.episodeData.timeline[this.currentChapter].NextChapter == "STOP" ) {
					this.video.pause()
					smarttag && smarttag('aflevering'+this.$route.params.id+'.video_bekeken')

					setTimeout(() => {
						if(!this.stopEpisode) {
							this.$router.go(-1)
							this.$store.commit('SHOW_EPISODE', false)
							this.$store.commit('SHOW_WEBSITE', true)
							this.stopEpisode = true
						}
					}, 1000)
				} else {
					this.$store.commit('SET_CURRENT_CHAPTER', this.episodeData.timeline[this.currentChapter].NextChapter)
				}
			}
		},
		onLoadStart: function() {
			this.$store.commit('SET_CURRENT_CHAPTER', Object.keys(this.episodeData.timeline)[0])
		}
	}
}

</script>

<style>

.overlay {
	position: absolute;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
}

.video {
	width: 100%;
	height: auto;
}

.scale-fade-enter-active, .scale-fade-leave-active {
	transition: opacity 0.6s, transform 0.6s;
	transform-origin: center bottom;
}

.scale-fade-enter, .scale-fade-leave-to {
	opacity: 0;
	transform: scale(.9);
}

.play-button {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 160px;
	height: 160px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// Episode.vue?76e03262